/**
 * trimDocumentFormat
 * @param textHtml :string
 * @returns textHtml :string
 */
export const trimDocumentFormat = function (textHtml: string) {
  return textHtml
    .replace(/<!--\[[\s\S]*?-->/g, '')
    .replace(/<!--[a-zA-Z]*?-->/g, '')
    .replace(/<!--\s|-->\s/g, '')
    .replace(/\s(ShowingPlcHdr|Temporary|DocPart|Title|SdtTag|ID)="(.*?)"/g, '')
    .replace(/@(font-face|page)[{[\s\S]*?}/g, '')
    .replace(/<(meta|link)[\s\S]*?>/g, '')
    .replace(/\/\*[\s\S]*?\*\//g, '');
};
